var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSamePromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39615 0.576172C2.70089 0.576172 2.06256 0.82733 1.60123 1.31693C1.14423 1.80192 0.923706 2.45328 0.923706 3.1476V22.0047C0.923706 22.699 1.14423 23.3505 1.60123 23.8354C2.06256 24.325 2.70089 24.5762 3.39615 24.5762H14.6044C15.2995 24.5762 15.9379 24.325 16.3992 23.8354C16.8562 23.3505 17.0767 22.699 17.0767 22.0047V3.1476C17.0767 2.45328 16.8562 1.80192 16.3992 1.31693C15.9379 0.82733 15.2995 0.576172 14.6044 0.576172H3.39615Z",
    fill: "#B3D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 7.43345C9.94677 7.43345 10.7143 6.66594 10.7143 5.71917C10.7143 4.77239 9.94677 4.00488 8.99999 4.00488C8.05322 4.00488 7.28571 4.77239 7.28571 5.71917C7.28571 6.66594 8.05322 7.43345 8.99999 7.43345Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamePromotion);
export default __webpack_public_path__ + "static/media/same-promotion.473580fe.svg";
export { ForwardRef as ReactComponent };